import { useNavigate } from 'react-router-dom';
import { AUTHORIZATION_FAILED_STATE_KEY } from '@gov-nx/component/common/Autorizace/constants';
import { useLatest } from '@gov-nx/core/hooks/State/useLatest';
import type { Optional } from '@gov-nx/core/types/helpers.types';
import { isNonEmptyString } from '@gov-nx/core/types/helpers.types';
import { pageRouteResolver } from '@gov-nx/web/Router/routeResolver';

export const useFailedSubmissionRedirect = () => {
	const navigate = useNavigate();
	const latestNavigate = useLatest(navigate);

	const redirectToFailedSubmission = (formularPodaniId: Optional<string>) => {
		if (!isNonEmptyString(formularPodaniId)) {
			latestNavigate.current(pageRouteResolver('dashboard'), { replace: true });
			return;
		}
		latestNavigate.current(
			pageRouteResolver('moje-podani.autorizace.detail', { formularPodaniId }),
			{ replace: true, state: { [AUTHORIZATION_FAILED_STATE_KEY]: true } }
		);
	};

	return { redirectToFailedSubmission };
};
